import { Check, Circle } from '@phosphor-icons/react';

import { cn } from '../../utils/cn';

/**
 * `.pen` `ds/row/picker-item--default` / `--selected` — ícone monocromático
 * (a cor não varia por item; só o estado default/selected muda a tinta).
 */
export function QuickCreatePickerRow({ icon: Icon, name, subtitle, selected, onSelect, ariaLabel }) {
  return (
    <button
      type="button"
      onClick={onSelect}
      aria-pressed={selected}
      aria-label={ariaLabel || name}
      className={cn(
        'flex w-full items-center gap-space-3 rounded-ds-md border p-space-3 text-left transition-colors',
        selected
          ? 'border-2 border-sage-500 bg-sage-tint shadow-[0_6px_18px] shadow-sage-glow'
          : 'border-border bg-card hover:bg-muted',
      )}
    >
      <span
        className={cn(
          'flex h-9 w-9 shrink-0 items-center justify-center rounded-ds-md',
          selected ? 'bg-card' : 'bg-muted',
        )}
      >
        {Icon ? (
          <Icon
            size={18}
            className={selected ? 'text-sage-on-tint' : 'text-muted-foreground'}
            aria-hidden
          />
        ) : null}
      </span>
      <span className="min-w-0 flex-1">
        <span className="type-body block truncate font-semibold text-card-foreground">
          {name}
        </span>
        {subtitle ? (
          <span className="type-label block truncate font-normal text-muted-foreground">
            {subtitle}
          </span>
        ) : null}
      </span>
      {selected ? (
        <Check size={18} className="shrink-0 text-sage-on-tint" aria-hidden />
      ) : (
        <Circle size={18} className="shrink-0 text-input-border" aria-hidden />
      )}
    </button>
  );
}
